export default __webpack_public_path__ + "navigation-examples-building-extrusion-1200-6bf4756501c7b56f392c7ba10ffdfcb9.png";